import React from "react";
import CText from "../../common/CText";
import { View,Dimensions } from "react-native";
import CImage from "../../common/CImage";
import LoanNotAppliedIcon from "../../assets/images/loanNotAppliedIcon.png";
import LoanPendingIcon from '../../assets/images/loanPending.png'
import SuccessIcon from '../../assets/images/Success.png'
import Common from "../../common/Common";
import CHeader from "../../common/CHeader";
import CustomButton from "../../common/CustomButton";
import {
    CreateResponsiveStyle,
    DEVICE_SIZES,
    useDeviceSize,
} from "rn-responsive-styles";

export default function StatusBlock(props) {
    const isSmallDevice = Dimensions.get("window").width < 767;
    const styles = useStyles()

    let statusCode = "";
    let message = "You’ve not applied for Used Car Loan";
    let data = {
        applicationId: "NE",
        status: "No application",
        subStatus: "Never applied",
        secondaryStatus: "Please apply for loan to see the status",
        loanUpdateStatus:""
    };

    if (props && props.statusData && props.statusData.data) {
        statusCode = props.statusData.statusCode;
        message = props.statusData.message;
        data = props.statusData.data;
    }
    console.log(props,"kkkk")

    let btnTitle = "Back to Used Car Loan";
    let headerIcon = LoanNotAppliedIcon;
        if (data.loanUpdateStatus === "inProgress") {
            btnTitle = "Complete & submit application";
            headerIcon = LoanPendingIcon;
        } else if (data.applicationId != ("NE" || "")) {
            btnTitle = "Back to Track Status"
        } else if (data.loanUpdateStatus === ("Completed" || "completed")) {
            headerIcon = SuccessIcon;
        }

    const onPressBtn = () => {
        if (data.loanUpdateStatus === "inProgress") {
            props.setActiveScreen('EmpInformation');
        }else if (data.applicationId != ("NE" || "")) {
            props.setActiveScreen("TrackStatusApplications")
        }  else {
            props.setActiveScreen("TrackStatus");
        }
    }

    const onBackPress = () => {
        if(props.fromScreen == "CustomerInformation"){
            props.setActiveScreen("CarLoanIndex");
        }
       else if (data.applicationId != ("NE" || "")) {
            props.setActiveScreen("TrackStatusApplications")
        }  else {
            props.setActiveScreen("TrackStatus");
        }
    }

    return (
        <>
            <View>
                <CHeader onPress={() =>onBackPress()} title="Back"></CHeader>
            </View>
            <View style={styles.contentWrapper}>
                <CImage.LoanStatusIcon src={headerIcon} />
                <CText.statusTitle>{message}</CText.statusTitle>
                <View style = {styles.statusBlockWrapper}> 
                    <Common.statusBlock 
                        styles ={{width:'100%'}}
                        contentStyles = {{paddingHorizontal : isSmallDevice ? 10 : 100 }}
                        data={data} />
                    </View>
                <View style={styles.buttonWrapper}>
                    <CustomButton text={btnTitle} onPress={() => onPressBtn()} />
                </View>
            </View>
        </>
    );
}

const useStyles = CreateResponsiveStyle({
    contentWrapper: {
        display: "flex",
        alignItems: "center",
        paddingTop: 20,
        gap: 20,
    },
    buttonWrapper: { width: 272, height: 44, borderRadius: 22 },
    statusBlockWrapper : {width: 386.8},
},{
    [DEVICE_SIZES.LG]: {
    

    },
    [DEVICE_SIZES.MD]: {
        
    },
    [DEVICE_SIZES.SM]: {
        
    },
    [DEVICE_SIZES.XS]: {
        statusBlockWrapper : {width: 270.8},
        
    }
}
)
